// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"93":"list","180":"story","435":"firebase-messaging","580":"qtc-react-brightcove","600":"qtc-react-youtube","634":"qtc-react-dailymotion","701":"firebase-app","946":"qtc-parsecsv"}[chunkId] || chunkId) + "-" + __webpack_require__.h().slice(0, 20) + ".js";
};